export const STRINGS = {
  FAQ: 'FAQ',
  ADD_A_QUERY: 'Add a query',
  NAME: 'Name',
  PHONE_NUMBER: 'Phone number',
  OUERY: 'Query',
  SUBMIT: 'Submit',
}
